import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'

import { getProps } from '../../math-vault'

export const getStaticProps = getStaticPropsWrapper(getProps, { campaign: true, path: '/math-vault' })

export { default } from '../../math-vault'
